import { withTranslation } from "next-i18next";
import { useSubscriptionEligibleTo } from "@hooks/use-current-user";
import Button from "@components/core/Button";
import Image from "@components/core/Image";
import Link from "@components/core/Link";
import DrawerUnlockEarlyTunnel from "./DrawerUnlockEarlyTunnel";

function DrawerClosetUnavailable({ t }) {
  const subscriptionEligibleTo = useSubscriptionEligibleTo();

  if (subscriptionEligibleTo === "unlock_early") return <DrawerUnlockEarlyTunnel />;

  return [
    <div className="drawer-body bg-white" key="drawer-closet-unavailable-body">
      <div className="d-flex flex-column align-items-center py-4 px-3 text-center">
        <h5 className="pt-2 mb-2">{t('common:drawer.modal_closet_unavailable.you_have_no_current_closet')}</h5>
        <p className="mb-4 px-5 text-gray">{t('common:drawer.modal_closet_unavailable.if_you_have_a_problem_contact_us')}</p>
        <Image
          src="lockedBagRetro"
          alt="locked-bag"
          className="mb-4"
          width={120}
          height={140}
        />
      </div>
    </div>,
    <div className="bg-white p-3 border-top" key="drawer-closet-unavailable-footer">
      <Link href={t("common:drawer.modal_closet_unavailable.contact_us.link")}>
        <Button
          fullWidth
          variant="primary"
        >
          {t("common:drawer.modal_closet_unavailable.contact_us.text")}
        </Button>
      </Link>
    </div>,
  ];
};

export default withTranslation("common")(DrawerClosetUnavailable);
